export class TermsAndConditions {
  public static FedRAMPConfirmationMessage: string =
    `      1. Users are accessing a U.S. Government information system
      2. Information system usage may be monitored, recorded, and subject to audit
      3. Unauthorized use of the information system is prohibited and subject to criminal and civil penalties
      4. Use of the information system indicates consent to monitoring and recording
      5. The data processed by application will be considered CUI, and should be protected and disseminated appropriately.

      I have read and understood all of the above.`;
}
